import { render, staticRenderFns } from "./FlowApprovationBox.vue?vue&type=template&id=6c235db8&"
import script from "./FlowApprovationBox.vue?vue&type=script&lang=js&"
export * from "./FlowApprovationBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports